import type { NextPage } from "next";
import { NskHead } from "~/components/common/head/NskHead";
import { VendorLayoutV2 } from "~/components/common/layouts/VendorLayoutV2";
import { Page as Component } from "~/components/specifics/vendors/settings/vendor_partners/Page";
import { useVendorPartners } from "~/hooks/vendors/useVendorPartners";

export const PATH = "/vendors/settings/vendor_partners";

const VendorPartnerSetting: NextPage = () => {
	const { data: vendorPartners } = useVendorPartners().index();

	return (
		<>
			<NskHead title="協力会社設定" />
			<VendorLayoutV2>
				{vendorPartners === null ? null : (
					<Component vendorPartners={vendorPartners} />
				)}
			</VendorLayoutV2>
		</>
	);
};

export default VendorPartnerSetting;
